// extracted by mini-css-extract-plugin
export var detail = "PageHeader-module--detail--623bc";
export var detailsSection = "PageHeader-module--detailsSection--eb6ae";
export var ratingBox = "PageHeader-module--ratingBox--228ae";
export var ratingsBreakdown = "PageHeader-module--ratingsBreakdown--33cfc";
export var ratingsBreakdownContainer = "PageHeader-module--ratingsBreakdownContainer--eef96";
export var reviewsContainer = "PageHeader-module--reviewsContainer--f5c95";
export var reviewsLabel = "PageHeader-module--reviewsLabel--eeea6";
export var spacer = "PageHeader-module--spacer--fc79e";
export var titleSection = "PageHeader-module--titleSection--2d11c";
export var titleSection__stars = "PageHeader-module--titleSection__stars--f52ea";
export var titleSection__subtitle = "PageHeader-module--titleSection__subtitle--8b890";